import { FormFieldContainer } from '../../components';
import { checkCondition } from '../../helpers';
import { ConditionalDefaultSync } from './ConditionalDefaultSync';

interface ConditionalFieldsProps {
  field?: Record<string, any>;
  formik?: Record<string, any>;
  useGridStyles?: boolean;
}

export const ConditionalFields = ({
  field = {},
  formik,
  useGridStyles = false,
}: ConditionalFieldsProps = {}) => {
  const { conditionConfig = {}, conditionalDefault } = field;
  const isConditionMet = checkCondition(formik?.values, conditionConfig);

  if (!isConditionMet) return null;

  // Handle custom fields for conditional fields
  if (field?.type === 'custom' && field.Field) {
    return <field.Field formik={formik} {...field?.props} />;
  }

  return (
    <>
      <FormFieldContainer
        item={field}
        formik={formik}
        useGridStyles={useGridStyles}
      />
      {conditionalDefault !== null && conditionalDefault !== undefined && (
        <ConditionalDefaultSync
          name={field.name}
          defaultValue={conditionalDefault}
        />
      )}
    </>
  );
};
